export class User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
 
  image: string;
  emailConfirmed: boolean;
  companyIds: number[];
  roleIds: number[];

  constructor(id?: number, firstName?: string, lastName?: string, email?: string, password?: string, confirmPassword?: string, image?: string, emailConfirmed?: boolean, companyIds?: number[], roleIds?: number[]) {
    this.id = id ? id : 0;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
   
    this.image = image ? image : '';
    this.emailConfirmed = emailConfirmed ? emailConfirmed : false;
    this.companyIds = companyIds ? companyIds : [];
    this.roleIds = roleIds ? roleIds : [];
  }
}
